let lastScrollTop = 0
window.addEventListener("scroll", function titleScroll() {
  let st = window.pageYOffset
  // console.log(st)
  translateRight("project1")
  translateLeft("project2")
  translateRight("project3")
  translateRight("contact")

  function translateLeft(id) {
    document.querySelector("#" + id).style.left =
    (st - document.querySelector("#" + id).offsetParent.offsetTop + 100) /
    10 +
    "vw"
    if (st > lastScrollTop) {
      document.querySelector("#" + id).style.transform = "skew(5deg)"
    } else {
      document.querySelector("#" + id).style.transform = "skew(-5deg)"
    }
  }
  function translateRight(id) {
    document.querySelector("#" + id).style.right =
      (st - document.querySelector("#" + id).offsetParent.offsetTop + 100) /
        10 +
      "vw"
    if (st > lastScrollTop) {
      document.querySelector("#" + id).style.transform = "skew(-5deg)"
    } else {
      document.querySelector("#" + id).style.transform = "skew(5deg)"
    }
  }
  lastScrollTop = st
})
